/** Visual theme variants for layout components */
export enum ComponentTheme {
  CARD = 'card',
  RAW = 'raw',
}
